import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"

import Sidebar from "./Sidebar"
import Toolbar from "./Toolbar"
import Products from "./Products"
import LoadMore from "./LoadMore"
import Skeleton from "./Skeleton"
import NoResults from "./NoResults"

import { updateSearchTagging } from "../../helpers"

export default function Serp() {
    const { query, response: { products }, loading } = useAppState();
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const foundProducts = products && products.total > 0;
    const docCount = products?.total ?? 0;

    useEffect(() => {
        if(!query.query) return;
        updateSearchTagging(query.query);
    }, [ query?.query ])

    useEffect(() => {
        document.querySelector('body')?.classList?.toggle('overflow-hidden', sidebarOpen);
        return () => document.querySelector('body')?.classList?.remove('overflow-hidden');
    }, [sidebarOpen])

    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen)
    }

    return (
        <div className="ns-serp" data-nosto-element="search">
            {foundProducts ? (
                <>
                    <Sidebar 
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                    />
                    <div className="ns-serp-innner ns-flex ns-flex-col">
                        <div className="ns-search-header ns-flex ns-items-center ns-justify-center">
                            <h2 className="ns-search-title ns-text-center" data-nosto-element="totalResults">
                                We found {docCount} {(docCount === 1) ? 'result' : 'results'} for "{query.query}".
                            </h2>
                        </div>
                        <Toolbar 
                            toggleSidebar={toggleSidebar}
                        />
                        <Products />
                        <LoadMore />
                    </div>
                </>
            ) : loading ? (
                <Skeleton />
            ) : (
                <NoResults />
            )}
        </div>
    )
}
